export default {
      id: "qr-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#qr",
      toString: function () {
        return this.url;
      }
    }